import Icon, { type IconProps } from '@cobliteam/ui/icons';
import { getSingular } from '@cobliteam/utils/pluralize';
import { memo } from 'react';
import type { DataWithCategory } from '../types';

interface ItemContentProps {
  item: DataWithCategory;
}

export const ItemContent = memo(({ item }: ItemContentProps) => {
  if (!item) return null;
  const label = item?.[item.category.labelKey as keyof DataWithCategory] || '';

  return (
    <button type='button' tabIndex={0} className={'flex w-full items-center justify-between text-xs '}>
      <div className='flex items-center justify-center gap-2'>
        {item.category.loading ? (
          <Icon name='loader-circle' className='size-3 animate-spin' />
        ) : (
          <Icon name={item.category.icon} color={item.category.color as IconProps['color']} />
        )}
        <div className='flex flex-col text-left'>
          <span className='text-[10px] text-gray-10'>{getSingular(item.category.name)}</span>
          <span className='line-clamp-1'>{label as string}</span>
        </div>
      </div>
    </button>
  );
});
